import React, { useState, useEffect } from 'react';
import './Pages.css';

const SettledClaims = ({ userRole }) => {
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchSettledClaims();
  }, []);

  const fetchSettledClaims = async () => {
    try {
      const response = await fetch('https://main.victriedemos.com:3017/api/claims');
      const data = await response.json();

      if (data.success) {
        // Filter Settled claims
        const settledClaims = data.claims.filter(claim => {
          const status = claim.Status?.toLowerCase() || '';
          return status === 'settled';
        });
        setClaims(settledClaims);
      }
    } catch (err) {
      console.error('Error fetching claims:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewClaim = async (claimId) => {
    setShowModal(true);
    try {
      const response = await fetch(`https://main.victriedemos.com:3017/api/claims/${claimId}`);
      const data = await response.json();
      
      if (data.success) {
        setSelectedClaim(data.claim);
      }
    } catch (err) {
      console.error('Error fetching claim details:', err);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES'
    }).format(amount);
  };

  if (loading) {
    return <div className="page-container"><div className="loading">Loading settled claims...</div></div>;
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Settled Claims</h1>
          <p>Completed and paid - {claims.length} claim{claims.length !== 1 ? 's' : ''}</p>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Claim #</th>
              <th>Client</th>
              <th>Policy #</th>
              <th>Product</th>
              <th>Incident Date</th>
              <th>Claim Amount</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {claims.length === 0 ? (
              <tr>
                <td colSpan="8" style={{ textAlign: 'center' }}>No settled claims</td>
              </tr>
            ) : (
              claims.map((claim) => (
                <tr key={claim.ClaimId}>
                  <td><strong>{claim.ClaimNumber}</strong></td>
                  <td>{claim.ClientName}</td>
                  <td>{claim.PolicyNumber}</td>
                  <td>{claim.ProductName}</td>
                  <td>{new Date(claim.DateOfIncident).toLocaleDateString()}</td>
                  <td>{formatCurrency(claim.ClaimAmount)}</td>
                  <td>
                    <span className="status-badge active">
                      {claim.Status}
                    </span>
                  </td>
                  <td>
                    <button 
                      className="btn btn-small btn-view"
                      onClick={() => handleViewClaim(claim.ClaimId)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* View Claim Modal */}
      {showModal && selectedClaim && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content large-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Claim Details - {selectedClaim.ClaimNumber}</h2>
              <button className="close-btn" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <div className="modal-body">
              <div className="detail-section">
                <h3>Claim Information</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <label>Claim Number:</label>
                    <span><strong>{selectedClaim.ClaimNumber}</strong></span>
                  </div>
                  <div className="detail-item">
                    <label>Claim Type:</label>
                    <span>{selectedClaim.ClaimType}</span>
                  </div>
                  <div className="detail-item">
                    <label>Date of Incident:</label>
                    <span>{new Date(selectedClaim.DateOfIncident).toLocaleDateString()}</span>
                  </div>
                  <div className="detail-item">
                    <label>Date Reported:</label>
                    <span>{new Date(selectedClaim.DateReported).toLocaleDateString()}</span>
                  </div>
                  <div className="detail-item">
                    <label>Claim Amount:</label>
                    <span><strong>{formatCurrency(selectedClaim.ClaimAmount)}</strong></span>
                  </div>
                  <div className="detail-item">
                    <label>Status:</label>
                    <span>
                      <span className="status-badge active">
                        {selectedClaim.Status}
                      </span>
                    </span>
                  </div>
                </div>
                <div className="detail-item full-width">
                  <label>Claim Narration:</label>
                  <p className="narration-text">{selectedClaim.ClaimNarration}</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettledClaims;
